import { IntegrationChannelType, IntegrationType } from 'generated/graphql';

interface GetIsCohortFileUploadIntegrationParams {
  channelType: IntegrationChannelType;
  integrationType: IntegrationType;
}

export const getIsCohortFileUploadIntegration = ({
  channelType,
  integrationType,
}: GetIsCohortFileUploadIntegrationParams) => {
  return (
    integrationType === IntegrationType.Cohorts &&
    channelType === IntegrationChannelType.FileUpload
  );
};
